import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { schema as shared } from '../../../../lightings/lightings-1/sections/footer/footer.schema'

const SOCIAL_PLATFORMS = ['facebook', 'instagram', 'youtube', 'tiktok', 'linkedin', 'x']
  .map(value => ({ label: value === 'x' ? 'X' : value[0]!.toUpperCase() + value.slice(1), value }))

/** The Contact column's two buttons and the logo column. */
const PROJUKTI_FIELDS: FieldSchema[] = [
  { key: 'locationUrl', label: '"Our location" link', type: 'string', placeholder: 'https://maps.google.com/…', help: 'Empty = a map search for the shop address.' },
  { key: 'complaintUrl', label: '"Complaint box" link', type: 'string', placeholder: '/contact', help: 'Empty = no Complaint box button.' },
  { key: 'badgesTitle', label: 'Logo column title', type: 'string', default: 'Affiliation' },
  {
    key: 'badges',
    label: 'Affiliation and partner logos',
    type: 'array',
    help: 'Shown on white tiles in the last column; the first logo is wide.',
    itemSchema: [
      { key: 'image', label: 'Logo', type: 'image' },
      { key: 'alt', label: 'Name', type: 'string' },
      { key: 'href', label: 'Link', type: 'string' },
    ],
  },
]

/**
 * Projukti footer: the shared footer fields (stored data stays portable) with the platforms its icons support,
 * plus the Contact column's buttons and the affiliation logos. Phone, email and address fall back to Store info.
 */
export const schema: ComponentSchema = {
  ...shared,
  label: 'Footer',
  description: 'Graphite footer: contact column, link columns, affiliation logos and a payment strip.',
  variants: [{ id: 'v1', label: 'Graphite, four columns' }],
  commonFields: [
    ...shared.commonFields
      .filter(f => f.key !== 'title')
      .map((f): FieldSchema => (f.key !== 'socialLinks'
        ? f
        : { ...f, itemSchema: f.itemSchema?.map(i => (i.key === 'platform' ? { ...i, options: SOCIAL_PLATFORMS } : i)) })),
    ...PROJUKTI_FIELDS,
  ],
}
